import { busquedaConstants } from '../_constants';

export function busqueda(state = {}, action) {
  switch (action.type) {
    case busquedaConstants.BUSCADOR_MAIN_OPTION_SET:
      return {
        ...state,
        option: action.option
      }; 
      
      case busquedaConstants.BUSCADOR_RESULTADOS:
        return {
          ...state,
          data: action.data
        }; 

        /*
         * `traerFiltros` ya no trae versiones, asi que se conservan las que se hayan cargado
         * por modelo: si no, una recarga de filtros (el ABM de marcas/modelos la dispara)
         * vaciaba los combos de version que ya estaban andando.
         */
        case busquedaConstants.BUSCADOR_FILTROS:
          return {
            ...state,
            filtros: {
              ...action.filtros,
              versiones: action.filtros?.versiones || state.filtros?.versiones || [],
              modelosConVersionesCargadas: state.filtros?.modelosConVersionesCargadas || []
            }
          }; 

        /*
         * Las versiones llegan de a un modelo por vez y se van acumulando en la misma lista
         * que antes traia `traerFiltros`. Asi los combos siguen leyendo `filtros.versiones` y
         * filtrando por modelo como siempre: no se enteran de que ahora se cargan de a poco.
         */
        case busquedaConstants.BUSCADOR_VERSIONES_MODELO:
          return {
            ...state,
            filtros: {
              ...(state.filtros || {}),
              versiones: [
                ...(state.filtros?.versiones || []).filter(
                  (it) => it.modelo?.id !== action.modeloId
                ),
                ...action.versiones
              ],
              modelosConVersionesCargadas: [
                ...((state.filtros || {}).modelosConVersionesCargadas || []).filter(
                  (id) => id !== action.modeloId
                ),
                action.modeloId
              ]
            }
          }; 

          
          case busquedaConstants.LIMPIAR_PRODUCTO:
          return {
            ...state,
            producto: undefined
          }; 
          
        case busquedaConstants.PRODUCTO_SELECCIONADO:
          return {
            ...state,
            producto: action.producto
          }; 

          
    default:
      return state
  }
}